<template>
  <div>
    <JqxWindow ref="myWindow" :theme="'material'"  :maxWidth="dialogWidth" :width="dialogWidth" :height="dialogHeight" :resizable="true" :isModal="true"
               :autoOpen="false" :initContent="init" @open="myWindowOnOpen()" @close="myWindowOnClose">
      <!--@open="init()"-->
      <div class="col-md"><strong>Missione</strong>
      </div>
      <div>
        <JqxTabs ref="tab" :theme="'material'" :animationType="'fade'" :autoCreate="false"
                 @tabclick="onTabClick($event)">
          <!--          :initTabContent="initWidgets"-->
          <ul style="margin-left: 5px">
            <li>Dati generali</li>
            <li>Corpo missione</li>
          </ul>
          <div>
            <JqxSplitter ref="splitteruscite" :width="850" :height="430" :autoCreate="true">
              <div class="splitter-panel" :theme="'material'">
                <div style="margin-top: 5px;margin-left: 5px;">
                  <div class="form-group">
                    <label>Impianto depositante</label>
                    <br>
                    <JqxComboBox ref="impianto_depositante"
                                 :dropDownHeight="250"
                                 :autoComplete="true"
                                 :popupZIndex="10000" :displayMember="'ragione_sociale'"
                                 :valueMember="'id'"
                                 :source="dataAdapterImpianti" :theme="'material'"
                                 @close="onClose($event)"></JqxComboBox><!--@change="onClose($event)"-->
                  </div>
                  <div class="form-group">
                    <label>Cliente dell'impianto depositante</label>
                    <br>
                    <JqxComboBox ref="cliente"
                                 :width="'90%'"
                                 :dropDownHeight="250"
                                 :autoComplete="true"
                                 :popupZIndex="10000" :displayMember="'ragione_sociale'"
                                 :valueMember="'id'" :selectedIndex="0"
                                 :source="dataAdapterClienti" :theme="'material'"
                    ></JqxComboBox>
                  </div>
                  <div class="form-group">
                    <label>Data uscita merce</label>
                    <br>
                    <JqxDateTimeInput :formatString="'yyyy-MM-dd'" :theme="'material'" ref="data_uscita_merce"></JqxDateTimeInput>
                  </div>
                  <div class="form-group">
                    <label>Documento cliente</label>
                    <br>
                    <JqxInput :theme="'material'" ref="documento_cliente"></JqxInput>
                  </div>
                  <div class="form-group">
                    <label>Contrassegno</label>
                    <br>
                    <JqxInput :theme="'material'" ref="contrassegno"></JqxInput>
                  </div>
                </div>
              </div>
              <div class="splitter-panel" :theme="'material'">
                <div style="margin-top: 5px;margin-left: 5px;">
                  <div class="form-group">
                    <label>Annotazioni DDT</label>
                    <br>
                    <JqxTextArea :height="80" :theme="'material'" ref="annotazioni_ddt"></JqxTextArea>
                  </div>
                  <div class="form-group">
                    <label>Note per magazzino</label>
                    <br>
                    <JqxTextArea :height="80" :theme="'material'" ref="note_per_magazzino"></JqxTextArea>
                  </div>
                </div>
              </div>
            </JqxSplitter>
<!--            <div class="form-group">-->
<!--              <label>Impianto depositante</label>-->
<!--              <br>-->
<!--              <JqxComboBox :autoDropDownHeight="true" ref="impianto_depositante"-->
<!--                           :popupZIndex="10000" :displayMember="'ragione_sociale'"-->
<!--                           :valueMember="'id'"-->
<!--                           :source="dataAdapterImpianti" :theme="'material'"-->
<!--                           @close="onClose($event)"></JqxComboBox>&lt;!&ndash;@change="onClose($event)"&ndash;&gt;-->
<!--            </div>-->
<!--            <div class="form-group">-->
<!--              <label>Cliente dell'impianto depositante</label>-->
<!--              <br>-->
<!--              <JqxComboBox :autoDropDownHeight="true" ref="cliente"-->
<!--                           :popupZIndex="10000" :displayMember="'ragione_sociale'"-->
<!--                           :valueMember="'id'" :selectedIndex="0"-->
<!--                           :source="dataAdapterClienti" :theme="'material'"-->
<!--              ></JqxComboBox>-->
<!--            </div>-->
<!--            <div class="form-group">-->
<!--              <label>Data uscita merce</label>-->
<!--              <br>-->
<!--              <JqxDateTimeInput :theme="'material'" ref="data_uscita_merce"></JqxDateTimeInput>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label>Documento cliente</label>-->
<!--              <br>-->
<!--              <JqxInput :theme="'material'" ref="documento_cliente"></JqxInput>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label>Annotazioni DDT</label>-->
<!--              <br>-->
<!--              <JqxInput :theme="'material'" ref="annotazioni_ddt"></JqxInput>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label>Note per magazzino</label>-->
<!--              <br>-->
<!--              <JqxInput :theme="'material'" ref="note_per_magazzino"></JqxInput>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label>Numero DDT secondario</label>-->
<!--              <br>-->
<!--              <JqxInput :theme="'material'" ref="numero_ddt_secondario"></JqxInput>-->
<!--            </div>-->
          </div>
          <div>
            <JqxDetailsIngressiUscite ref="DetailsIngressiUscite"></JqxDetailsIngressiUscite>
          </div>
        </JqxTabs>
        <card>
          <div class="float-right">
            <!--                        <JqxButton :theme="'material'" @click="saveParent">-->
            <JqxButton ref="save" :theme="'material'" @click="waitSave">
              Save
            </JqxButton>

            <JqxButton :theme="'material'" @click="cancelParent">
              Cancel
            </JqxButton>
          </div>
        </card>
      </div>
    </JqxWindow>
  </div>
</template>

<script>
  import JqxWindow from "~jqx/jqwidgets-vue/vue_jqxwindow.vue";
  import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
  import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";
  import JqxTextArea from "~jqx/jqwidgets-vue/vue_jqxtextarea.vue";
  import JqxNumberInput from "~jqx/jqwidgets-vue/vue_jqxnumberinput.vue";
  import JqxSplitter from '~jqx/jqwidgets-vue/vue_jqxsplitter.vue';
  import JqxComboBox from "~jqx/jqwidgets-vue/vue_jqxcombobox.vue";
  import JqxDateTimeInput from "~jqx/jqwidgets-vue/vue_jqxdatetimeinput.vue";
  import JqxGrid from "~jqx/jqwidgets-vue/vue_jqxgrid.vue";
  import JqxTabs from '~jqx/jqwidgets-vue/vue_jqxtabs.vue';
  import JqxDetailsIngressiUscite from "./JqxDetailsIngressiUscite";

  let cliente;

  export default {
    name: "UsciteDetails",
    components: {
      JqxDetailsIngressiUscite,
      JqxInput,
      JqxTextArea,
      JqxNumberInput,
      JqxButton,
      JqxWindow,
      JqxSplitter,
      JqxComboBox,
      JqxDateTimeInput,
      JqxGrid,
      JqxTabs
    },
    data: function () {
      return {
        dialogWidth: (window.innerWidth - 40),
        dialogHeight: (window.innerHeight - 40),
        panels: [{size: 200}, {size: 200}],
        dataAdapterImpianti: new jqx.dataAdapter(this.sourceanagraficaimpianti),
        dataAdapterClienti: new jqx.dataAdapter(this.sourceanagraficaclienti),
        checkEmptyGrid: 0,
      }
    },
    beforeCreate: function () {
      this.sourceanagraficaimpianti = {
        datatype: 'json',
        datafields: [
          {name: 'ragione_sociale'},
          {name: 'id'},
        ],
        url: '/api/cruds/read?t=AnagraficaImpianti&q=allforsourceinput'
      };
      this.sourceanagraficaclienti = {
        datatype: 'json',
        datafields: [
          {name: 'ragione_sociale'},
          {name: 'id'},
          {name: 'impianto_depositante'},
        ],
        url: '/api/cruds/read?t=AnagraficaClienti&q=allforsourceinput'
      };
    },

    mounted: function () {
      //console.log("Mounted!");
    },

    destroyed: function () {
      //console.log("Destroyed!");
    },
    methods: {
      onTabClick: function (tab) {
        switch (tab.args.item) {
          case 0:

            break;
          case 1:
            this.checkEmptyGrid = 1;
            this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.dataCreationCustomDetails();
            // try {
            //   this.$refs.DetailsIngressiUscite.$refs.myGridDetails.setcolumnindex('articolo', 0);
            //   this.$refs.DetailsIngressiUscite.$refs.myGridDetails.setcolumnindex('descrizione_articolo_id', 1);
            //   this.$refs.myGridDetails.setcolumnindex('quantita_dichiarata', 5);
            // } catch (err) {
            //
            // }
            break;
        }
      },
      waitSave() {
        this.$refs.save.setOptions({disabled: true});
        setTimeout(() => this.saveParent(), 300);
      },
      saveParent() {
        let checkcliente = this.$refs.cliente.getSelectedIndex();
        if (checkcliente != -1) {
          this.$refs.DetailsIngressiUscite.$refs.myGridDetails.clearfilters();
          this.$nextTick(() => {
            let data = this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.getvalori();
            //console.log('data: ', data);
            let empty_check = data.some((el) => {
              // let empty = Object.values(el).some((el2)=>{return (el2 === null || el2 === "")});
              // let length = Object.values(el).length;
              // //console.log("el: ", el);
              // //console.log("el lenght: ", length);
              let empty = false;
              if (!el.articolo_id || !el.descrizione_articolo_id || !el.unita_di_misura || !el.quantita_caricata) {
                empty = true;
              }
              return (empty);
            });
            if (this.checkEmptyGrid === 1 && data.length < 1) {
              alert('Attenzione! Non è stato inserito alcun articolo all\'interno del corpo dell\'uscita. Correggere per continuare.');
            } else if (this.checkEmptyGrid === 1 && empty_check) {
              alert('Attenzione! Uno o più articoli all\'interno del corpo dell\'uscita non sono completi. Correggere per continuare.');
            } else {
              this.$parent.saveBtn(data);
            }
            this.$refs.save.setOptions({disabled: false});
          })
        } else {
          alert('Attenzione! Non è stato selezionato alcun cliente. Selezionare un cliente per procedere.');
          this.$refs.save.setOptions({disabled: false});
        }
      },
      cancelParent() {
        this.$parent.cancelBtn();
      },
      onClose: function (event) {
        //console.log(this.$refs.impianto_depositante.val())
        //console.log(this.$refs.cliente.val())
        // this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.setQueryModel('/api/cruds/read?t=GestioneUsciteCorpo&q=impianto_depositante-' + this.$refs.impianto_depositante.val());
        //this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.setQueryModel('/api/cruds/read?t=GestioneUsciteCorpo&q=id-' + this.$refs.impianto_depositante.val());
        this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.setImpianto(this.$refs.impianto_depositante.val());
        //this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.dataCreationCustomDetails();
        let impianto_depositante = this.$refs.impianto_depositante.val();

        this.$refs.cliente.setOptions({disabled: false, selectedIndex: -1});
        //let value = event.args.item.value;
        let clienteSource = this.$refs.cliente.source._source;
        clienteSource.data = {impianto_depositante: impianto_depositante};
        let index = -1;

        let dataAdapterClienti = new jqx.dataAdapter(clienteSource, {
          beforeLoadComplete: (records) => {
            let filteredRecords = new Array();
            let counter = -1;
            for (let i = 0; i < records.length; i++) {
              if (records[i].impianto_depositante == impianto_depositante) {
                counter++;
                filteredRecords.push(records[i]);
                if (cliente && cliente.value == records[i].id) {
                  index = counter;
                }
              }
            }
            return filteredRecords;
          },
          loadComplete: (data) => {
            this.$refs.cliente.selectIndex(index);
          }
        });
        this.$refs.cliente.setOptions({
          source: dataAdapterClienti,
        });

        // this.$refs.cliente.selectIndex("0");
        // this.$refs.cliente.val(1);

        // if(cliente){
        //     this.$refs.cliente.selectItem(cliente.value);
        //     // this.$refs.cliente.selectIndex(cliente);
        // }


        // this.sourceanagraficaclienti = {
        //   datatype: 'json',
        //   datafields: [
        //     {name: 'ragione_sociale'},
        //     {name: 'id'},
        //   ],
        //   url: '/api/cruds/read?t=AnagraficaClienti&q=allforsourceinput-' + impianto_depositante
        // };
        // this.$refs.cliente.source = new jqx.dataAdapter(this.sourceanagraficaclienti);

      },
      init: function () {
        let options = {height: "480px", theme: "material"/*, initTabContent: this.initWidgets*/};
        this.$refs.tab.createComponent(options);
        //this.$refs.DetailsIngressiUscite.$refs.myGridDetails.createComponent();
        this.reorderColum();
      },
      myWindowOnOpen: function () {
        if (this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.getvalori()) {
          this.$refs.DetailsIngressiUscite.$refs.myGridDetails.clear();
        }
        let impianto = this.$refs.impianto_depositante.getSelectedIndex() != -1 ? this.$refs.impianto_depositante.getSelectedIndex() : 0;
        //cliente = this.$refs.cliente.getSelectedIndex() != -1 ? this.$refs.cliente.getSelectedIndex() : 1;
        cliente = this.$refs.cliente.getSelectedItem();

        // this.$refs.cliente.val(cliente.value);

        this.$refs.impianto_depositante.selectIndex(impianto);
        this.onClose();
      },
      myWindowOnClose: function () {
        let clienteSource = this.$refs.cliente.source._source;
        let dataAdapterClienti = new jqx.dataAdapter(clienteSource);
        this.$refs.cliente.setOptions({
          source: dataAdapterClienti,
        });
        this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.resetGrid();
      },
      setDateCustom: function () {
        this.$refs.data_uscita_merce.setDate(new Date());
      },
      newRowCheckGrid: function (isNew) {
        //console.log(isNew);
        this.checkEmptyGrid = isNew;
      },
      reorderColum: function () {
        //Imposto ordine colonne da front-end
        // try {
        //     if (this.$refs.tab.val() === 1) {
        //         this.$refs.DetailsIngressiUscite.$refs.myGridDetails.setcolumnindex('articolo', 0);
        //         this.$refs.DetailsIngressiUscite.$refs.myGridDetails.setcolumnindex('descrizione_articolo_id', 1);
        //         // this.$refs.myGridDetails.setcolumnindex('quantita_dichiarata', 5);
        //     }
        // } catch (err) {
        //
        // }
      },
      // onTabclick: function () {
      //   //Ordino le colonne come da default al momento della creazione tabella secondaria jqxDetailsIngressiUscite
      //     this.reorderColum();
      //
      // }
    }
  }
</script>

<style scoped>
  .jqx-splitter {
    border: none;
  }
</style>
